import React, { memo } from 'react';
import { Typography, Button } from '../../../../../components';
import { useNotificationContext } from '../../../../../providers';
import { useUploadDiscoveryImportFileMutation } from '../../../../../api';
import { IMPORT_TYPES } from '../../../../../constants/discovery';
const { Paragraph, Title } = Typography;

export const ReviewContents = memo(({
    form,
    fileList,
    orgId,
    resetForm,
    isUploading,
    setIsUploading,
    setStep,
    setActiveImportId,
}) => {
    const { notifyError } = useNotificationContext();
    const [uploadDiscoveryImportFile] = useUploadDiscoveryImportFileMutation();

    const addToInventory = async () => {
        setIsUploading(true);
        try {
            const importName = form.getFieldValue('importName');
            const result = await uploadDiscoveryImportFile({
                file: fileList[0]?.originFileObj,
                orgId,
                importName,
                toolId: IMPORT_TYPES.rvTools,
            }).unwrap();
            setActiveImportId(result?.id ?? null);
            setStep(3);
        } catch (error) {
            if (error?.status === 415) {
                notifyError({
                    message: 'Unsupported File Type',
                    description: 'The file format is not supported. Please upload a valid ZIP, XLS, or XLSX file.',
                    duration: 10,
                });
            } else {
                notifyError({
                    message: 'Upload Failed',
                    description: error?.data?.message || 'An error occurred while uploading RVTools data.',
                    duration: 10,
                });
            }
            resetForm();
        } finally {
            setIsUploading(false);
        }
    };

    return (
        <div className="review-contents">
            <Title level={2}>Review Contents Below</Title>
            <Paragraph>
                Review the imported data from your RV Tools CSV before adding it to your inventory. Make sure the
                columns and values look correct before proceeding.
            </Paragraph>
            <div className="button-group">
                <Button type="default" size="medium" disabled={isUploading} onClick={resetForm}>
                    Restart
                </Button>
                <Button type="primary" size="medium" onClick={addToInventory} loading={isUploading}>
                    {isUploading ? 'Adding to Inventory...' : 'Add to Inventory'}
                </Button>
            </div>
        </div>
    );
});
